import { Disclosure } from "@headlessui/react";
import { FunnelIcon } from "@heroicons/react/24/outline";
import { ReactNode, Dispatch, SetStateAction } from "react";
import Checkbox from "./checkbox";
import Searchbox from "./searchbox";
import { allOrders, allRisk, allHabitats } from "config";

export default function SearchFilter({
	children,
	riskFilters,
	orderFilters,
	habitatFilters,
	setRiskFilters,
	setOrderFilters,
	setHabitatFilters,
}: {
	children: ReactNode;
	riskFilters: string[];
	orderFilters: string[];
	habitatFilters: string[];
	setRiskFilters: Dispatch<SetStateAction<string[]>>;
	setOrderFilters: Dispatch<SetStateAction<string[]>>;
	setHabitatFilters: Dispatch<SetStateAction<string[]>>;
}) {
	return (
		<Disclosure as="section" aria-labelledby="filter-heading" className="relative z-10 grid items-center border-t border-b border-gray-200">
			<h2 id="filter-heading" className="sr-only">
				Filters
			</h2>
			<div className="relative col-start-1 row-start-1 py-4">
				<div className="mx-auto flex-wrap space-x-6 divide-gray-200 px-4 text-sm sm:flex sm:divide-x sm:px-6 lg:px-8">
					<div className="flex-1 pl-4 text-center text-sm ">{children}</div>
					<div className="mt-2 flex-1 justify-center text-center sm:mt-0">
						<Disclosure.Button className="group flex w-full items-center justify-center text-center font-medium text-gray-700">
							<FunnelIcon className="mr-2 h-5 w-5 flex-none text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
							{(riskFilters.length !== 0 ? 1 : 0) + (orderFilters.length !== 0 ? 1 : 0) + (habitatFilters.length !== 0 ? 1 : 0)} Filter
							{(riskFilters.length !== 0 ? 1 : 0) + (orderFilters.length !== 0 ? 1 : 0) + (habitatFilters.length !== 0 ? 1 : 0) !== 1 && "s"}
						</Disclosure.Button>
					</div>
				</div>
			</div>
			<Disclosure.Panel className="border-t border-gray-200 py-10">
				<div className="mx-auto max-w-7xl gap-x-4 px-4 text-sm sm:px-6 md:gap-x-6 lg:px-8">
					<div className="grid auto-rows-min grid-cols-1 gap-y-10 md:grid-cols-3 md:gap-x-6">
						<Checkbox name={"Risk Level"} options={allRisk} filters={riskFilters} setFilters={setRiskFilters} />
						<div className="col-span-2">
							<div className="grid grid-rows-2 gap-y-10">
								<Searchbox name={"Order"} options={allOrders} filters={orderFilters} setFilters={setOrderFilters} />
								<Searchbox name={"Habitat"} options={allHabitats} filters={habitatFilters} setFilters={setHabitatFilters} />
							</div>
						</div>
					</div>
				</div>
			</Disclosure.Panel>
		</Disclosure>
	);
}
